// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bUpE","col":"styles_col__114c8","actions":"styles_actions__2fM7_","conflict":"styles_conflict__1GBTI"};